module.exports = __webpack_public_path__ + "img/ky.ef1f6537.svg";